import { FieldWrapper } from '@progress/kendo-react-form'
import { DropDownTree, DropDownTreeChangeEvent, DropDownTreeExpandEvent } from "@progress/kendo-react-dropdowns";
import React from "react";
import { Label } from "@progress/kendo-react-labels";
import { TicketApi } from "../../../redux/api/TicketApi";
import { expandedState, processTreeData } from "../../../utils/TreeDataOperations";
import { ITemplateListItem } from '../../../types/Ticket/ITemplate';
import { Api } from '../../../redux/api/BaseApi';
import { useCurrentUserContext } from '../../../context/UserContext';

export const TemplateList: React.FunctionComponent<TemplateListProps> = props => {
    const selectField = "selected";
    const expandField = "expanded";
    const dataItemKey = "Id";
    const subItemsField = "Templates";

    const { data: template } = TicketApi.useGetTemplateQuery(props.templateId, { skip: !props.templateId });
    const { data: templates, isLoading } = TicketApi.useGetMyTemplatesQuery();
    const { profile: userProfile } = useCurrentUserContext();

    const selectedTemplate = { Id: props.templateId, Name: props.templateId ? template?.Call_Template_Name : null } //templates?.map(t => t.Templates.filter(t2=>t2.Id === props.templateId)
    const [value, setValue] = React.useState(selectedTemplate);
    const [open, setOpen] = React.useState<boolean>();
    const [expanded, setExpanded] = React.useState([templates?.length && templates?.[0][dataItemKey]]);


    const onChange = (event: DropDownTreeChangeEvent) => {
        //console.log('event', expanded, expanded.includes(event?.value?.Id))
        if (event?.value && event?.value.Id < 0) {
            if (!expanded.includes(event?.value.Id))
                setExpanded([event?.value.Id]); //expand
            else
                //let newArray = [...expanded].splice(expanded.indexOf(event?.value.Id)
                setExpanded((oldVal) => {
                    let newVal = [...oldVal]
                    newVal.splice(expanded.indexOf(event?.value.Id), 1)
                    return newVal;
                }); //collaps
            setOpen(true); //stay open

            return
        }

        if (!event.value || !props.hasDescription || window.confirm(`Changing the template will REPLACE the ${userProfile.Phrases.CallPhrase} ${userProfile.Phrases.Description}. Are you sure you want to continue?`)) {
            setValue(event.value);
            props.onChange(event)
            setOpen(undefined); //Close
        }
    }
    const onExpandChange = React.useCallback(
        (event: DropDownTreeExpandEvent) =>
            setExpanded(expandedState(event.item, dataItemKey, expanded)),
        [expanded]
    );

    const treeData = React.useMemo(
        () => {
            const fields = { selectField, expandField, dataItemKey, subItemsField };
            //console.log('processTreeData', selectedTemplate, value)
            let tree = processTreeData(templates || [], { expanded, value }, fields)
            //console.log('processTreeData2', tree)
            return tree
        }, [expanded, value, templates]
    );

    return (
        <FieldWrapper>
            <Label>
                {/* Template */}
            </Label>
            <div className={"k-form-field-wrap"}>
                <DropDownTree data={treeData} loading={isLoading} placeholder="Select..."
                    onBlur={() => setOpen(undefined)}
                    opened={open}
                    value={selectedTemplate}
                    dataItemKey="Id"
                    textField="Name"
                    subItemsField="Templates"
                    onChange={onChange}
                    selectField={selectField}
                    expandField={expandField}
                    onExpandChange={onExpandChange}
                />
            </div>
        </FieldWrapper>
    )
}

type TemplateListProps = {
    templateId?: number;
    hasDescription?: boolean;
    onChange?: (e: { value: ITemplateListItem; }) => void;
}